import { Platform } from 'react-native';
import * as SecureStore from 'expo-secure-store';
import { readWebStorage, writeWebStorage } from './web-storage';
import { createSecureStoreKey } from './secure-store-key';

const SEEN_PREFIX = 'tabbio_tour_seen_v1';

function storageKey(userId?: string | null) {
  return userId ? createSecureStoreKey(SEEN_PREFIX, userId) : null;
}

function readStorage(key: string) {
  if (Platform.OS === 'web') {
    return readWebStorage(key);
  }

  try {
    return SecureStore.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string) {
  if (Platform.OS === 'web') {
    writeWebStorage(key, value);
    return;
  }

  try {
    void SecureStore.setItemAsync(key, value);
  } catch {
    // Best effort: tour persistence must never block UX.
  }
}

export function hasSeenTour(userId?: string | null): boolean {
  const key = storageKey(userId);
  if (!key) return true;
  return readStorage(key) === '1';
}

export function markTourSeen(userId?: string | null) {
  const key = storageKey(userId);
  if (!key) return;
  writeStorage(key, '1');
}
